import type {NavigationDirection} from '../navigationDirection';
import {TRANSITION_BEHAVIOR_TYPE, type TransitionBehavior} from './transitionBehavior.types';

type TransitionBehaviorContext = {
    incomingKey: number;
    lastCommittedLocationKey: number;
    explicitDirection: NavigationDirection;
};

export const resolveTransitionBehavior = ({
    incomingKey,
    lastCommittedLocationKey,
    explicitDirection,
}: TransitionBehaviorContext): TransitionBehavior => {
    if (incomingKey === lastCommittedLocationKey) {
        return {type: TRANSITION_BEHAVIOR_TYPE.IGNORE};
    }

    return {type: TRANSITION_BEHAVIOR_TYPE.ANIMATE, direction: explicitDirection};
};
